import React from 'react'
import {
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions
} from 'material-ui/Card'
import { Button } from 'components'
import { AnalyticsUtils, Enum } from 'utils'

const JOB_TYPE = "Speed"

export default class SpeedFixesCard extends React.Component {
  static propTypes = {
    source: React.PropTypes.string
  }

  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  componentDidMount() {
    AnalyticsUtils.recommendedJobViewed(JOB_TYPE)
  }

  handleClickedLearnMore() {
    AnalyticsUtils.learnMoreButtonClicked(JOB_TYPE)
  }

  render() {
    return (
      <Card key='speedfixes' className='recommended-job-card' style={{borderRadius: 10}} onTouchTap={ () => { location.href = 'https://www.blimpon.com/pages/speed-up-your-shopify-store-compass' } }>
        <CardMedia mediaStyle={{borderRadius: '10px 10px 0 0'}}>
          <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/HJxlMLksjV.png' style={{borderRadius: '10px 10px 0 0'}}/>
        </CardMedia>
        <CardTitle
          title={<h2 className="small-spacing2">Speed up your store</h2>}
          subtitle='$49 - $320 one-off fee'
          style={{paddingBottom: 12}}
        />
        <CardText style={{padding: '0 16px'}}>
          <ul className='icon-font-list'>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Tailored speed analysis and fixes for your shop</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>A tangible increase in your loading time</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Fixed-price with a 100% money-back guarantee</li>
          </ul>
        </CardText>
        <CardActions style={{padding: 16}}>
          <Button
            label="Notify Me"
            buttonType="secondary"
            href="https://forms.gle/B9aCx2VwmYuMxj2T9"
            onTouchTap={::this.handleClickedLearnMore}
          />
        </CardActions>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/jobs/SpeedFixesCard.js